import type { PreBookingShipment } from "@freightsimple/generated-dashboard-openapi-client/models/PreBookingShipment";
import type { SavedLocation } from "@freightsimple/generated-dashboard-openapi-client/models/SavedLocation";
import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";

import BookShipmentAddressScreenComponent from "./CustomComponents/BookShipmentAddressScreenComponent";

interface BookShipmentDeliveryAddressScreenProps {
  shipment: PreBookingShipment;
  savedLocations: Array<SavedLocation>;
  loading: boolean;
  onComplete: () => void;
  nextIdentifier: string;
  onPrevious: () => Promise<void>;
  markLocationAsFavourite: boolean | undefined;
  onMarkLocationAsFavourite: (newValue: boolean) => void;
  onModify: () => void;
}

function BookShipmentDeliveryAddressScreen(
  props: BookShipmentDeliveryAddressScreenProps,
) {
  return (
    <BookShipmentAddressScreenComponent
      identifier={"delivery-address"}
      savedLocations={props.savedLocations}
      context={LocationContext.Delivery}
      shipment={props.shipment}
      nextIdentifier={props.nextIdentifier}
      onPrevious={props.onPrevious}
      loading={props.loading}
      onComplete={props.onComplete}
      markLocationAsFavourite={props.markLocationAsFavourite}
      onMarkLocationAsFavourite={props.onMarkLocationAsFavourite}
      onModify={props.onModify}
      isSameDayPickup={false}
    />
  );
}

export default BookShipmentDeliveryAddressScreen;
